import React from 'react';
import PropTypes from 'prop-types';
import head from 'lodash.head';
import isEmpty from 'lodash.isempty';
import { getWordClassName } from '../../../../utils/shared/probeDetailUtils';
import { generateReactKey } from '../../../../utils/shared/commonUtils';

const buildMultiSound = (segment, phonemeClassName, isSelfCorrected, segmentIndex) => (
    <div key={generateReactKey(segmentIndex, phonemeClassName)} className="multisound">
        <div>
            {segment.map((phoneme, index) => (
                <div key={generateReactKey(index)} className={`letter ${phonemeClassName}`}>
                    {phoneme}
                    {isSelfCorrected && index === 0 && <sup>sc</sup>}
                </div>
            ))}
        </div>
    </div>
);

const getLineClassName = (columnIndex, startIndex, length) => {
    let lineClassName = 'on';
    if (length > 1) lineClassName = 'blended';
    return columnIndex >= startIndex && columnIndex < startIndex + length ? lineClassName : null;
};

const NwfBox = props => {
    const {
        word,
        score,
        is_full_word_recoded: isFullWordRecoded,
        segmentation,
        segments,
        self_corrected_phonemes: selfCorrectedItems,
        incorrect_phonemes: incorrectItems,
    } = props.wordItem;
    return (
        <div className="detail-box">
            <div className="header-row">
                <div className="header-item word">{word}</div>
                <div data-test-id="nwf-score" className="header-item">
                    CLS: {score || 0}/{segmentation.length}
                </div>
                <div data-test-id="nwf-score" className="header-item">
                    WRC: {isFullWordRecoded ? 1 : 0}/1
                </div>
            </div>
            <div className="detail-row letters">
                {segmentation.map((segment, segmentIndex) => {
                    const isSelfCorrected = isEmpty(selfCorrectedItems)
                        ? null
                        : selfCorrectedItems.includes(segmentIndex);
                    const isIncorrectItem = isEmpty(incorrectItems)
                        ? null
                        : incorrectItems.includes(segmentIndex);
                    const phonemeClassName = getWordClassName(isSelfCorrected, isIncorrectItem);
                    const isMultiSound = segment.length > 1;
                    return isMultiSound ? (
                        buildMultiSound(segment, phonemeClassName, isSelfCorrected, segmentIndex)
                    ) : (
                        <div
                            key={generateReactKey(segmentIndex)}
                            className={`letter ${phonemeClassName}`}
                        >
                            {head(segment)}
                            {isSelfCorrected && <sup>sc</sup>}
                        </div>
                    );
                })}
            </div>
            {!isEmpty(segments) &&
                segments.map(
                    (
                        { length, starting_phoneme: startIndex, has_extra_sound: hasExtraSound },
                        index,
                    ) => (
                        <div
                            key={generateReactKey(index)}
                            data-test-id="nwf-lines"
                            className="detail-row"
                        >
                            {segmentation.map((letter, columnIndex) => (
                                <div
                                    key={generateReactKey(index, columnIndex)}
                                    className={`letter ${getLineClassName(
                                        columnIndex,
                                        startIndex,
                                        length,
                                    )}`}
                                />
                            ))}
                            {hasExtraSound && <div className="extra-sound">/</div>}
                        </div>
                    ),
                )}
        </div>
    );
};

NwfBox.defaultProps = {
    wordItem: {},
};

NwfBox.propTypes = {
    wordItem: PropTypes.object,
};

export default NwfBox;
